import React from 'react';

export const SignalRContext = React.createContext<signalR.HubConnection | null>(null);
SignalRContext.displayName = 'SignalRContext';

export default SignalRContext;
